import React from "react"

export interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string
  alt?: string
  width?: number | string
  height?: number | string
  layout?: string
  objectFit?: string
  priority?: boolean
}

export const Image: React.FC<ImageProps> = ({
  src,
  alt = "",
  width,
  height,
  layout,
  objectFit,
  priority,
  ...props
}) => {
  return <img src={src} alt={alt} width={width} height={height} {...props} />
}

export default Image
